import React from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";

const SelectFormat = ({
  name,
  label,
  control,
  options,
  placeholder,
  onChange,
  required,
errors,
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold pb-1">
        {label} {required && <span className="mx-1 text-danger">*</span>}
      </Form.Label>
      <Controller
        control={control}
        name={name}
        // rules={{ required: true }}
        defaultValue=""
        render={({ field }) => (
          <select
            {...field}
            className={"form-select w-75"}
            size="sm"
            name={name}
            onChange={(e) => {
              field.onChange(e);
              onChange && onChange(e);
            }}
          >
            {placeholder && (
              <option disabled={true} value="">
                {placeholder}
              </option>
            )}
            {options.map((item) => (
              <option key={item.id || item.value} value={item.value}>
                {item.label}
              </option>
            ))}
            </select>
        )}
        />
        {errors && (<div
         className="text-danger">{errors[name]?.message}</div>)}
    </Form.Group>
  );
};

export default SelectFormat;
